var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { action, observe, observable } from "mobx";
import { InternalMessageBusChannels } from "sb-internal-msg-bus";
import { parseSportEvent, isEmptyObject } from "../helpers";
export class ScoreboardParser {
    constructor(props) {
        this.updateTimeZone = (data) => {
            if (this.timeZone !== data.currentSelectedTimeZone) {
                this.timeZone = data.currentSelectedTimeZone;
                this.onUpdateEvent(this.retriever.event);
            }
        };
        this.event = {};
        this.retriever = props.retriever;
        this.messageBus = props.messageBus;
        this.timeZone = 0;
    }
    activate(blockId) {
        this.eventDisposer = observe(this.retriever, "event", (change) => this.onUpdateEvent(change.newValue));
        this.retriever.activate(blockId);
        this.attachListeners();
        this.executeRequesters();
    }
    deactivate(blockId) {
        this.eventDisposer();
        this.retriever.deactivate(blockId);
        this.detachListeners();
    }
    onUpdateEvent(event) {
        !isEmptyObject(event) && (this.event = parseSportEvent(event, this.timeZone));
    }
    attachListeners() {
        this.messageBus.on(InternalMessageBusChannels.legacy.timeZone.update, this.onTimeZoneChange, this);
    }
    detachListeners() {
        this.messageBus.off(InternalMessageBusChannels.legacy.timeZone.update, this.onTimeZoneChange, this);
    }
    executeRequesters() {
        this.messageBus.emit(InternalMessageBusChannels.legacy.timeZone.request, { callback: this.updateTimeZone });
    }
    onTimeZoneChange(timeZoneMessage) {
        this.updateTimeZone(timeZoneMessage.data[0]);
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], ScoreboardParser.prototype, "event", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ScoreboardParser.prototype, "onUpdateEvent", null);
//# sourceMappingURL=ScoreboardParser.js.map